import type {DesignModuleSpecJson} from '../data/contracts';
import type {ModuleStudioRepository} from '../data/ModuleStudioRepository';
import {compileCachedNativeTemplate as compileNativeTemplate,type NativeCompilationCache} from './nativeCompilationCache';
import {nativeTemplatePrefix} from './nativeTemplatePrefix';
import {compactEmptyDecisionOrigins,decisionSha,journalOf} from './decisionJournal';

/** Captures remain in the immutable prototype import. Never trust a reference without its digest. */
export async function resolveCaptureOrigins(spec:DesignModuleSpecJson,repository:ModuleStudioRepository,compilationCache?:NativeCompilationCache):Promise<DesignModuleSpecJson>{
 const next=JSON.parse(JSON.stringify(spec)) as DesignModuleSpecJson,journal=journalOf(next),reads=new Map<string,Promise<string>>();
 for(const origin of journal.origins){
  if(origin.root.captureRef!==origin.sha256)continue;
  const {importRef,pieceRef}=origin.prototypeRef;
  if(typeof importRef!=='string'||typeof pieceRef!=='string')throw Error('replay.source_piece_missing');
  const key=JSON.stringify([importRef,pieceRef]);
  if(!reads.has(key))reads.set(key,repository.getPrototypePieceText(importRef,pieceRef));
  const html=await reads.get(key)!;
  if(await decisionSha(html)!==origin.sha256)throw Error('replay.source_digest_mismatch');
  const compiled=await compileNativeTemplate(html,String(origin.root.captureModule??spec.module.code),origin.page,String(origin.root.capturePrefix??nativeTemplatePrefix(spec)),compilationCache,typeof origin.prototypeRef.selector==='string'?origin.prototypeRef.selector:undefined);
  Object.assign(origin,compiled.origin);
 }
 if(next.decisionJournal)next.decisionJournal=journal;
 return next;
}

/** Replace only exactly reconstructible origins; non-capture Maker evidence stays inline. */
export async function compactCaptureOrigins(spec:DesignModuleSpecJson,repository:ModuleStudioRepository,compilationCache?:NativeCompilationCache):Promise<DesignModuleSpecJson>{
 if(!spec.decisionJournal)return spec;
 const next=await resolveCaptureOrigins(spec,repository,compilationCache),journal=compactEmptyDecisionOrigins(journalOf(next));
 const reads=new Map<string,Promise<string>>();
 for(const origin of journal.origins){
  const {importRef,pieceRef}=origin.prototypeRef;
  if(typeof importRef!=='string'||typeof pieceRef!=='string'||!origin.fingerprints)continue;
  const key=JSON.stringify([importRef,pieceRef]);
  if(!reads.has(key))reads.set(key,repository.getPrototypePieceText(importRef,pieceRef));
  const html=await reads.get(key)!;
  if(await decisionSha(html)!==origin.sha256)throw Error('replay.source_digest_mismatch');
  const compiled=await compileNativeTemplate(html,String(spec.module.code),origin.page,nativeTemplatePrefix(spec),compilationCache,typeof origin.prototypeRef.selector==='string'?origin.prototypeRef.selector:undefined);
  if(JSON.stringify(origin.root)!==JSON.stringify(compiled.origin!.root)||JSON.stringify(origin.messages)!==JSON.stringify(compiled.origin!.messages)||JSON.stringify(origin.fingerprints)!==JSON.stringify(compiled.origin!.fingerprints))continue;
  origin.root={captureRef:origin.sha256,capturePrefix:nativeTemplatePrefix(spec),captureModule:String(spec.module.code)};origin.messages={};delete origin.fingerprints;
 }
 next.decisionJournal=journal;return next;
}
